/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { BannerListResponseDTO, CreateBannerDTO, OutBannerDTO, PutBannerDTO } from "../models";
import {
  BannerListResponseDTOFromJSON,
  BannerListResponseDTOToJSON,
  CreateBannerDTOFromJSON,
  CreateBannerDTOToJSON,
  OutBannerDTOFromJSON,
  OutBannerDTOToJSON,
  PutBannerDTOFromJSON,
  PutBannerDTOToJSON
} from "../models";

export interface DeleteBannerRequest {
  bannerId: number;
}

export interface FindAllByPlatformIdRequest {
  platformId: number;
  filters?: string;
  returnDefault?: boolean;
  bannerType?: FindAllByPlatformIdBannerTypeEnum;
}

export interface GetBannerByIdRequest {
  bannerId: number;
}

export interface GetBannerBySlugRequest {
  bannerSlug: string;
}

export interface GetBannersExtendedRequest {
  skip: number;
  take: number;
  platformId?: number;
  searchQuery?: string;
  status?: GetBannersExtendedStatusEnum;
  bannerType?: GetBannersExtendedBannerTypeEnum;
  live?: boolean;
}

export interface PostBannerRequest {
  createBannerDTO: CreateBannerDTO;
}

export interface PutBannerRequest {
  bannerId: number;
  putBannerDTO: PutBannerDTO;
}

/**
 *
 */
export class BannersApi extends runtime.BaseAPI {
  /**
   */
  async deleteBannerRaw(
    requestParameters: DeleteBannerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.bannerId === null || requestParameters.bannerId === undefined) {
      throw new runtime.RequiredError(
        "bannerId",
        "Required parameter requestParameters.bannerId was null or undefined when calling deleteBanner."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/banners/{bannerId}`.replace(
          `{${"bannerId"}}`,
          encodeURIComponent(String(requestParameters.bannerId))
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteBanner(
    requestParameters: DeleteBannerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.deleteBannerRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async findAllByPlatformIdRaw(
    requestParameters: FindAllByPlatformIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<OutBannerDTO>>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling findAllByPlatformId."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.returnDefault !== undefined) {
      queryParameters["returnDefault"] = requestParameters.returnDefault;
    }

    if (requestParameters.bannerType !== undefined) {
      queryParameters["bannerType"] = requestParameters.bannerType;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/banners`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OutBannerDTOFromJSON));
  }

  /**
   */
  async findAllByPlatformId(
    requestParameters: FindAllByPlatformIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<OutBannerDTO>> {
    const response = await this.findAllByPlatformIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getBannerByIdRaw(
    requestParameters: GetBannerByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutBannerDTO>> {
    if (requestParameters.bannerId === null || requestParameters.bannerId === undefined) {
      throw new runtime.RequiredError(
        "bannerId",
        "Required parameter requestParameters.bannerId was null or undefined when calling getBannerById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/banners/{bannerId}`.replace(
          `{${"bannerId"}}`,
          encodeURIComponent(String(requestParameters.bannerId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutBannerDTOFromJSON(jsonValue));
  }

  /**
   */
  async getBannerById(
    requestParameters: GetBannerByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutBannerDTO> {
    const response = await this.getBannerByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getBannerBySlugRaw(
    requestParameters: GetBannerBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutBannerDTO>> {
    if (requestParameters.bannerSlug === null || requestParameters.bannerSlug === undefined) {
      throw new runtime.RequiredError(
        "bannerSlug",
        "Required parameter requestParameters.bannerSlug was null or undefined when calling getBannerBySlug."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/banners/slug/{bannerSlug}`.replace(
          `{${"bannerSlug"}}`,
          encodeURIComponent(String(requestParameters.bannerSlug))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutBannerDTOFromJSON(jsonValue));
  }

  /**
   */
  async getBannerBySlug(
    requestParameters: GetBannerBySlugRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutBannerDTO> {
    const response = await this.getBannerBySlugRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getBannersExtendedRaw(
    requestParameters: GetBannersExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<BannerListResponseDTO>> {
    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling getBannersExtended."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling getBannersExtended."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.bannerType !== undefined) {
      queryParameters["bannerType"] = requestParameters.bannerType;
    }

    if (requestParameters.live !== undefined) {
      queryParameters["live"] = requestParameters.live;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/banners/extended`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => BannerListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getBannersExtended(
    requestParameters: GetBannersExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<BannerListResponseDTO> {
    const response = await this.getBannersExtendedRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async postBannerRaw(
    requestParameters: PostBannerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutBannerDTO>> {
    if (requestParameters.createBannerDTO === null || requestParameters.createBannerDTO === undefined) {
      throw new runtime.RequiredError(
        "createBannerDTO",
        "Required parameter requestParameters.createBannerDTO was null or undefined when calling postBanner."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/banners`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateBannerDTOToJSON(requestParameters.createBannerDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutBannerDTOFromJSON(jsonValue));
  }

  /**
   */
  async postBanner(
    requestParameters: PostBannerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutBannerDTO> {
    const response = await this.postBannerRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async putBannerRaw(
    requestParameters: PutBannerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutBannerDTO>> {
    if (requestParameters.bannerId === null || requestParameters.bannerId === undefined) {
      throw new runtime.RequiredError(
        "bannerId",
        "Required parameter requestParameters.bannerId was null or undefined when calling putBanner."
      );
    }

    if (requestParameters.putBannerDTO === null || requestParameters.putBannerDTO === undefined) {
      throw new runtime.RequiredError(
        "putBannerDTO",
        "Required parameter requestParameters.putBannerDTO was null or undefined when calling putBanner."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/banners/{bannerId}`.replace(
          `{${"bannerId"}}`,
          encodeURIComponent(String(requestParameters.bannerId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PutBannerDTOToJSON(requestParameters.putBannerDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutBannerDTOFromJSON(jsonValue));
  }

  /**
   */
  async putBanner(
    requestParameters: PutBannerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutBannerDTO> {
    const response = await this.putBannerRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const FindAllByPlatformIdBannerTypeEnum = {
  HERO_HEADER: "HERO_HEADER",
  SEARCH: "SEARCH",
  OVERVIEW: "OVERVIEW"
} as const;
export type FindAllByPlatformIdBannerTypeEnum =
  typeof FindAllByPlatformIdBannerTypeEnum[keyof typeof FindAllByPlatformIdBannerTypeEnum];
/**
 * @export
 */
export const GetBannersExtendedStatusEnum = {
  VISIBLE: "VISIBLE",
  INVISIBLE: "INVISIBLE",
  ALMOST_VISIBLE: "ALMOST_VISIBLE"
} as const;
export type GetBannersExtendedStatusEnum =
  typeof GetBannersExtendedStatusEnum[keyof typeof GetBannersExtendedStatusEnum];
/**
 * @export
 */
export const GetBannersExtendedBannerTypeEnum = {
  HERO_HEADER: "HERO_HEADER",
  SEARCH: "SEARCH",
  OVERVIEW: "OVERVIEW"
} as const;
export type GetBannersExtendedBannerTypeEnum =
  typeof GetBannersExtendedBannerTypeEnum[keyof typeof GetBannersExtendedBannerTypeEnum];
